import styled from 'styled-components';
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  
  font-size: 14px;
  color: ${colors.charcoalGrey};
  
  > * {
    margin: 2px;
    min-width: 320px;
 }
`;

export const WorkOrderWrapper = styled.div`
  flex: 1.5;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  padding: 48px 64px;
  background-color: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${colors.paleGrey};
  
  > * {
    padding: 32px 0;
    border-bottom: 1px solid ${colors.paleGrey};
  }
  
  >:first-child {
    padding-bottom: 32px;
    border-bottom: 1px solid ${colors.paleGrey};
  }
  >:last-child {
    border-bottom: none;
  }
`;

export const CommentsWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: 48px 32px;
  background-color: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${colors.paleGrey};
  
  > * {
    padding: 0 0 32px 0;
    border-bottom: 1px solid ${colors.paleGrey};
  }
  
  >:last-child {
    border-bottom: none;
  }
  
  li {
    overflow: auto;
    list-style-type: none;
    
    max-height: 320px;
    
    &::-webkit-scrollbar {
      overflow:visible;
      height:6px;
      width:6px;
    }
    &::-webkit-scrollbar-button{
      height: 0;
      width: 0;
    }

    &::-webkit-scrollbar-track{
      background-clip: padding-box;
      border-radius: 10px;
      &:horizontal {
        border-width: 0 0 0;
      }
      &:hover {
        background-color:${colors.white};
      }
      &:active{
        background-color:${colors.white};
      }
    }

    &::-webkit-scrollbar-thumb{
      background-color: ${colors.silver};
      background-clip: padding-box;
      min-height: 28px;
      padding: 100px 0 0;
      border-radius: 10px;
      opacity: 0;
      transition: .7s eaze;
      &:horizontal{
        padding: 0 0 0 100px;
      }
      &:active{
        background-color: darken(${colors.silver}, 20%)
      }
    }

    &::-webkit-scrollbar-corner{
      background: ${colors.transparent};
    } 

    &::-webkit-scrollbar-track-piece{
      background-clip:  padding-box;
      background-color: ${colors.white};
    }
    &::-webkit-scrollbar-corner {
      background-clip: padding-box;
      background-color: ${colors.white};
    }
  }
  ul {
    padding: 0;
  }
  ul > div > span:first-child {
    font-weight: bold;
    &:after {
        content: '·';
        font-weight: bold;
        margin: 4px;
    }
  }
  
  > div {
    display: flex;
    flex-flow: column wrap;
    padding-top: 16px;
    
    > * {
      margin-top: 8px;
    }
  }
`;

export const WorkOrderInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column wrap;

  h1 {
    margin: 0 0 4px 0;
  }

  .sub {
    > * {
      :after {
        content: '·';
        font-weight: bold;
        margin: 4px;
      }
      :last-child:after {
        content: none;
        margin: 0;
      }
    }
  }
  
  .profiles {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    
    img, svg {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      margin-right: 8px;
    }
    
    svg {
      fill: ${colors.silver};
    }
    
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    div > div {
      display: flex;
      flex-direction: column;
      
      span:first-child {
        color: ${colors.slateGrey};
      }
      
      span:last-child {
        font-weight: bold;
      }
    }
  }
`;

export const WorkOrderActivityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  max-height: 320px;
  
  li {
    overflow: auto;
    list-style-type: none;
    
    &::-webkit-scrollbar {
      overflow:visible;
      height:6px;
      width:6px;
    }
    &::-webkit-scrollbar-button{
      height: 0;
      width: 0;
    }

    &::-webkit-scrollbar-track{
      background-clip: padding-box;
      border-radius: 10px;
      &:horizontal {
        border-width: 0 0 0;
      }
      &:hover {
        background-color:${colors.white};
      }
      &:active{
        background-color:${colors.white};
      }
    }

    &::-webkit-scrollbar-thumb{
      background-color: ${colors.silver};
      background-clip: padding-box;
      min-height: 28px;
      padding: 100px 0 0;
      border-radius: 10px;
      opacity: 0;
      transition: .7s eaze;
      &:horizontal{
        padding: 0 0 0 100px;
      }
      &:active{
        background-color: darken(${colors.silver}, 20%)
      }
    }

    &::-webkit-scrollbar-corner{
      background: ${colors.transparent};
    } 

    &::-webkit-scrollbar-track-piece{
      background-clip:  padding-box;
      background-color: ${colors.white};
    }
    &::-webkit-scrollbar-corner {
      background-clip: padding-box;
      background-color: ${colors.white};
    }
  }

  ul {
    display: flex;
    flex-flow: column wrap;
    padding: 0;
    
    span:first-child {
      font-size: 18px;
    }
    span:last-child {
      color: ${colors.slateGrey};
    }
  }
`;

export const ButtonWrapper = styled.button`
  height: 44px;
  width: 144px;
  text-align: center;
  border-radius: 24px;
  
  background-color: ${colors.brightBlue};
  color: ${colors.white};
  border: 0;
  svg {
    fill: ${colors.white};
  }

  font-size: 16px;
  font-weight: 600;
  flex: 0 0 auto;
  cursor: pointer;
  outline: none;
`;
